import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Input,
  Radio,
  Icon,
  Label,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardEmployeePaymentDetailUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          id="CardEmployeePaymentDetailUX-Form-2">
          <FormGroup
            id="CardEmployeePaymentDetailUX-FormGroup-3"
            inline={true}>
            <FormField
              id="CardEmployeePaymentDetailUX-FormField-19"
              style={{flex: 1}}>
              <label
                id="CardEmployeePaymentDetailUX-label-183">
                {props.employeeFullName|| "-"}
              </label>
            </FormField>
            <FormField
              id="CardEmployeePaymentDetailUX-FormField-4">
              <div
                id="CardEmployeePaymentDetailUX-div-163">
                {props.loadingCheckbox}
              </div>
            </FormField>
            <FormField
              id="CardEmployeePaymentDetailUX-FormField-5"
              style={{padding:0, display:props.readOnly?"none":""}}>
              <Button
                color="green"
                id="CardEmployeePaymentDetailUX-Button-21"
                onClick={props.onClickAdd}
                size="small">
                {props.languageUX === "en" ? "ADD" : "เพิ่ม"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeePaymentDetailUX-div-16"
          style={{width: "100%"}}>

          <Table
            data={props.tableData}
            getTrProps={props.getTrProps}
            headers="Affiliation,Position,Salary /Wages,Base OT / hours,Position Pay,License Allowance,Language Pay,Level  skill Pay,Social Security,PVD,WHT Deduction,Net Amount,Start date,End date"
            id="CardEmployeePaymentDetailUX-Table-17"
            keys="affiliation_name,position_name,amount,base_ot,position_pay,license_allowance,language_pay,skill_pay,social_security_amount,provident_fund_amount,tax_deduction_amount,net_payment,start_date,end_date"
            minRows={3}
            showPagination={false}
            widths="^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80">
          </Table>
        </div>
        <div
          id="CardEmployeePaymentDetailUX-div-44"
          style={{display: props.detail? "":"none"}}>

          <div
            id="CardEmployeePaymentDetailUX-div-45"
            style={{color: "rgba(26, 115, 232, 1)", fontWeight: "bold", margin: "1rem 0 0.5rem"}}>
            {props.languageUX === "en" ? "Employee payment detail" : "รายละเอียดการจ่ายเงินพนักงาน"}
          </div>
          <div
            id="CardEmployeePaymentDetailUX-div-46"
            style={{display: "flex", backgroundColor: "rgba(191, 234, 251, 1)", borderRadius: "3px", marginBottom: "1rem", padding: "0.35rem"}}>

            <div
              id="CardEmployeePaymentDetailUX-div-47"
              style={{fontWeight: "bold", marginRight: "0.25rem"}}>
              {props.languageUX === "en" ? "Affiliation:" : "สังกัด:"}
            </div>
            <div
              id="CardEmployeePaymentDetailUX-div-48">
              {props.affiliateName}
            </div>
            <div
              id="CardEmployeePaymentDetailUX-div-49"
              style={{fontWeight: "bold", margin: "0 0.25rem  0 1rem"}}>
              {props.languageUX === "en" ? "Position:" : "ตำแหน่ง:"}
            </div>
            <div
              id="CardEmployeePaymentDetailUX-div-50">
              {props.positionName}
            </div>
          </div>
          <Form
            className="--override-disabled --grey"
            id="CardEmployeePaymentDetailUX-Form-51">
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-52"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.amount? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-53"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-57"
                  style={{fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Salary/Wages" : "เงินเดือน/ค่าจ้าง"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-61"
                  min={0}
                  name="amount"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.amount?? ""}>
                </Input>
                <div
                  id="CardEmployeePaymentDetailUX-div-171"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.amount|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-54"
                inline={true}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-58"
                  style={{fontWeight: "normal", width: "160px"}}>
                  {props.languageUX === "en" ? "Base OT / hours" : "ฐานโอที/ชั่วโมง"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-62"
                  min={0}
                  name="base_ot"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.base_ot ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-55"
                inline={true}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-59"
                  style={{fontWeight: "normal", width: "110px"}}>
                  {props.languageUX === "en" ? "Position Pay" : "เงินเดือนประจำตำแหน่ง"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-63"
                  min={0}
                  name="position_pay"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.position_pay ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-56"
                inline={true}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-60"
                  style={{fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "License Allowance" : "ค่าใบอนุญาต"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-64"
                  min={0}
                  name="license_allowance"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.license_allowance ?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-65"
              inline={true}>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-66"
                inline={true}
                width={3}>
                <div
                  id="CardEmployeePaymentDetailUX-div-69"
                  style={{display: "flex", minWidth: "max-content"}}>

                  <label
                    id="CardEmployeePaymentDetailUX-label-71">
                    {props.languageUX === "en" ? "Language Score" : "คะแนนภาษา"}
                  </label>
                  <div
                    id="CardEmployeePaymentDetailUX-div-72">
                    {props.langScoreInfo}
                  </div>
                </div>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-70"
                  min={0}
                  name="language_score"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.language_score ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-67"
                inline={true}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-73"
                  style={{fontWeight: "normal", width: "160px"}}>
                  {props.languageUX === "en" ? "Language Pay" : "การจ่ายเงินค่าภาษา"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-74"
                  min={0}
                  name="language_pay"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.language_pay ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-68"
                inline={true}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-77"
                  style={{fontWeight: "normal", width: "110px"}}>
                  {props.languageUX === "en" ? "Expiry Pay" : "การจ่ายเงินวันหมดอายุ"}
                </label>
                <div
                  id="CardEmployeePaymentDetailUX-div-75"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={props.readOnly}
                    id="CardEmployeePaymentDetailUX-DateTextBox-76"
                    onChange={(value: any)=>props.onChangeValue?.(null,{name: "language_expired_at", value})}
                    value={props.detail?.language_expired_at ?? ""}>
                  </DateTextBox>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-78"
              inline={true}>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-79"
                inline={true}
                width={3}>
                <div
                  id="CardEmployeePaymentDetailUX-div-81"
                  style={{display: "flex", minWidth: "max-content"}}>

                  <label
                    id="CardEmployeePaymentDetailUX-label-85">
                    Level skill Score
                  </label>
                  <div
                    id="CardEmployeePaymentDetailUX-div-86">
                    {props.levelSkillScoreInfo}
                  </div>
                </div>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-84"
                  min={0}
                  name="skill_score"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.skill_score ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-80"
                inline={true}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-82"
                  style={{fontWeight: "normal", width: "160px"}}>
                  {props.languageUX === "en" ? "Level skill Pay" : "ระดับทักษะ จ่าย"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-83"
                  min={0}
                  name="skill_pay"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.skill_pay ?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-87"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.has_social_security? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-89"
                inline={true}
                style={{position: "relative"}}
                width={4}>

                <label
                  id="CardEmployeePaymentDetailUX-label-106"
                  style={{fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Social Security Eligibility" : "สิทธิ์การเข้ารับประกันสังคม"}
                </label>
                <div
                  id="CardEmployeePaymentDetailUX-div-108"
                  style={{display: "flex"}}>

                  <Radio
                    checked={props.detail?.has_social_security ===true }
                    disabled={props.readOnly}
                    id="CardEmployeePaymentDetailUX-Radio-109"
                    label={props.languageUX === "en" ? "Yes" : "ใช่"}
                    name="has_social_security"
                    onChange={props.onChangeValue}
                    value={true}>
                  </Radio>
                  <Radio
                    checked={props.detail?.has_social_security === false}
                    disabled={props.readOnly}
                    id="CardEmployeePaymentDetailUX-Radio-110"
                    label={props.languageUX === "en" ? "No" : "เลขที่"}
                    name="has_social_security"
                    onChange={props.onChangeValue}
                    style={{marginLeft: "1rem"}}
                    value={false}>
                  </Radio>
                </div>
                <div
                  id="CardEmployeePaymentDetailUX-div-172"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", left: "0"}}>
                  {props.showRequiredField?.has_social_security|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-90"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-91"
                inline={true}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-103"
                  style={{fontWeight: "normal", minWidth: "200px"}}>
                  Social Security Deduction Amount
                </label>
                <Input
                  disabled={true}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-104"
                  value={props.detail?.social_security_amount??""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-92"
              inline={true}>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-94"
                inline={true}
                width={4}>
                <label
                  id="CardEmployeePaymentDetailUX-label-107"
                  style={{fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "% Provident Fund" : "% กองทุนสำรองเลี้ยงชีพ"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-99"
                  min="0"
                  name="provident_fund_perc"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.provident_fund_perc ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-95"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-96"
                inline={true}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-102"
                  style={{fontWeight: "normal", minWidth: "200px"}}>
                  {props.languageUX === "en" ? "Provident Fund Amount" : "จำนวนเงินกองทุนสำรองเลี้ยงชีพ"}
                </label>
                <Input
                  disabled={true}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-105"
                  value={props.detail?.provident_fund_amount ?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-111"
              inline={true}>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-112"
                inline={true}>
                <Button
                  color="blue"
                  disabled={props.readOnly}
                  icon={true}
                  id="CardEmployeePaymentDetailUX-Button-120"
                  onClick={props.onClickCalWHT}
                  size="mini"
                  type="button">
                  <Icon
                    id="CardEmployeePaymentDetailUX-Icon-121"
                    name="refresh">
                  </Icon>
                  <label
                    id="CardEmployeePaymentDetailUX-label-122"
                    style={{marginLeft: "6px"}}>
                    {props.languageUX === "en" ? "WHT CALCULATION" : "การคำนวณ WHT"}
                  </label>
                </Button>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-113"
                inline={true}
                width={2}>
                <Label
                  id="CardEmployeePaymentDetailUX-Label-123"
                  size="large"
                  style={{backgroundColor: "rgba(255, 244, 212, 1)", width: "100%"}}>
                  {props.formattedWHTAmount|| "\u00A0"}
                </Label>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-114"
                inline={true}>
                <label
                  id="CardEmployeePaymentDetailUX-label-124"
                  style={{fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Automatic WHT Calculation" : "การคำนวณ WHT อัตโนมัติ"}
                </label>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-115"
                inline={true}>
                <Radio
                  checked={props.detail?.isAutoWHTCalculation===true}
                  disabled={props.readOnly}
                  id="CardEmployeePaymentDetailUX-Radio-125"
                  label={props.languageUX === "en" ? "Yes" : "ใช่"}
                  name="isAutoWHTCalculation"
                  onChange={props.onChangeValue}
                  value={true}>
                </Radio>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-117"
                inline={true}>
                <Radio
                  checked={props.detail?.isAutoWHTCalculation===false}
                  disabled={props.readOnly}
                  id="CardEmployeePaymentDetailUX-Radio-126"
                  label={props.languageUX === "en" ? "No" : "เลขที่"}
                  name="isAutoWHTCalculation"
                  onChange={props.onChangeValue}
                  value={false}>
                </Radio>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-118"
                inline={true}
                width={6}>
                <label
                  id="CardEmployeePaymentDetailUX-label-127"
                  style={{fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Tax Deduction Conditions" : "เงื่อนไขการหักลดหย่อนภาษี"}
                </label>
                <Dropdown
                  clearable={true}
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Dropdown-128"
                  multiple={true}
                  name="tax_type"
                  onChange={props.onChangeValue}
                  options={props.revenueTaxTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.detail?.tax_type?? ""}>
                </Dropdown>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.tax_deduction_amount? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-119"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardEmployeePaymentDetailUX-label-129"
                  style={{fontWeight: "normal", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Amount" : "จำนวน"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-130"
                  min="0"
                  name="tax_deduction_amount"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+]$/.test(e.key) && e.preventDefault()}
                  type="number"
                  value={props.detail?.tax_deduction_amount?? ""}>
                </Input>
                <div
                  id="CardEmployeePaymentDetailUX-div-174"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.tax_deduction_amount|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-131"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.net_payment? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-135"
                inline={true}
                style={{position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-143"
                  style={{fontWeight: "normal", minWidth: "140px"}}>
                  {props.languageUX === "en" ? "Net pay amount" : "จำนวนเงินที่จ่ายสุทธิ"}
                </label>
                <Input
                  disabled={true}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Input-151"
                  value={props.detail?.net_payment??""}>
                </Input>
                <div
                  id="CardEmployeePaymentDetailUX-div-173"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.net_payment|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.payment_info? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-136"
                inline={true}
                style={{marginLeft: "5rem",position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-150"
                  style={{fontWeight: "normal", minWidth: "130px"}}>
                  {props.languageUX === "en" ? "Payment Information" : "ข้อมูลการชำระเงิน"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Dropdown-152"
                  name="payment_info"
                  onChange={props.onChangeValue}
                  options={props.salaryPaymentTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.detail?.payment_info ?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeePaymentDetailUX-div-175"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.payment_info|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-132"
              inline={true}>
              <FormField
                className={props.detail?.payment_info==="CASH"?"":`required ${props.showRequiredField?.bank ? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-137"
                inline={true}
                style={{position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-144"
                  style={{fontWeight: "normal", minWidth: "140px"}}>
                  {props.languageUX === "en" ? "Bank name" : "ชื่อธนาคาร"}
                </label>
                <Dropdown
                  disabled={props.detail?.payment_info==="CASH" || props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Dropdown-153"
                  name="bank"
                  onChange={props.onChangeValue}
                  options={props.bankOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.detail?.bank ?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeePaymentDetailUX-div-176"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.bank|| ""}
                </div>
              </FormField>
              <FormField
                className={props.detail?.payment_info==="CASH"?"":`required ${props.showRequiredField?.bank_branch? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-138"
                inline={true}
                style={{marginLeft: "5rem",position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-147"
                  style={{fontWeight: "normal", minWidth: "130px"}}>
                  {props.languageUX === "en" ? "Bank branch name" : "ชื่อสาขาธนาคาร"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  id="CardEmployeePaymentDetailUX-Dropdown-181"
                  name="bank_branch"
                  onChange={props.onChangeValue}
                  options={props.bankBranchOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.detail?.bank_branch ?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeePaymentDetailUX-div-177"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.bank_branch|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-133"
              inline={true}>
              <FormField
                className={props.detail?.payment_info==="CASH"?"":`required ${props.showRequiredField?.bank_account? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-139"
                inline={true}
                style={{position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-145"
                  style={{fontWeight: "normal", minWidth: "140px"}}>
                  {props.languageUX === "en" ? "Bank Account Number" : "หมายเลขบัญชีธนาคาร"}
                </label>
                <div
                  id="CardEmployeePaymentDetailUX-div-182"
                  style={{width: "100%"}}>
                  {props.bankAccount}
                </div>
                <div
                  id="CardEmployeePaymentDetailUX-div-178"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.bank_account|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-140"
                inline={true}
                style={{marginLeft: "5rem"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-149"
                  style={{fontWeight: "normal", minWidth: "130px"}}>
                  {props.languageUX === "en" ? "Bank account type" : "ประเภทบัญชีธนาคาร"}
                </label>
                <Dropdown
                  disabled={props.detail?.payment_info==="CASH" || props.readOnly}
                  fluid={true}
                  id="CardEmployeePaymentDetailUX-Dropdown-156"
                  name="bank_account_type"
                  onChange={props.onChangeValue}
                  options={props.bankAccountTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.detail?.bank_account_type ?? ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-134"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.start_date? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-141"
                inline={true}
                style={{position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-146"
                  style={{fontWeight: "normal", minWidth: "140px"}}>
                  {props.languageUX === "en" ? "Start Date" : "วันที่เริ่มต้น"}
                </label>
                <div
                  id="CardEmployeePaymentDetailUX-div-161"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={props.readOnly}
                    id="CardEmployeePaymentDetailUX-DateTextBox-162"
                    onChange={(value: any)=>props.onChangeValue?.(null,{name: "start_date", value})}
                    value={props.detail?.start_date ?? ""}>
                  </DateTextBox>
                </div>
                <div
                  id="CardEmployeePaymentDetailUX-div-179"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.start_date|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.end_date? "error" : ""}`}
                id="CardEmployeePaymentDetailUX-FormField-142"
                inline={true}
                style={{marginLeft: "5rem",position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeePaymentDetailUX-label-148"
                  style={{fontWeight: "normal", minWidth: "130px"}}>
                  {props.languageUX === "en" ? "End Date" : "วันที่สิ้นสุด"}
                </label>
                <div
                  id="CardEmployeePaymentDetailUX-div-159"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={props.readOnly}
                    id="CardEmployeePaymentDetailUX-DateTextBox-160"
                    onChange={(value: any)=>props.onChangeValue?.(null,{name: "end_date", value})}
                    value={props.detail?.end_date ?? ""}>
                  </DateTextBox>
                </div>
                <div
                  id="CardEmployeePaymentDetailUX-div-180"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.end_date|| ""}
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <Form
            id="CardEmployeePaymentDetailUX-Form-164">
            <FormGroup
              id="CardEmployeePaymentDetailUX-FormGroup-165"
              inline={true}
              style={{marginTop: "1.5rem"}}>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-166"
                inline={true}
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-167"
                inline={true}>
                <div
                  id="CardEmployeePaymentDetailUX-div-169">
                  {props.buttonSave}
                </div>
              </FormField>
              <FormField
                id="CardEmployeePaymentDetailUX-FormField-168"
                inline={true}>
                <Button
                  color="red"
                  id="CardEmployeePaymentDetailUX-Button-170"
                  onClick={props.onClickCancel}
                  size="small">
                  {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
                </Button>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardEmployeePaymentDetailUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Wed Aug 06 2025 12:27:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-4"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-5"
        },
        "style": {
          "type": "code",
          "value": "{padding:0, display:props.readOnly?\"none\":\"\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 17,
      "name": "Table",
      "parent": 16,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "Affiliation,Position,Salary /Wages,Base OT / hours,Position Pay,License Allowance,Language Pay,Level  skill Pay,Social Security,PVD,WHT Deduction,Net Amount,Start date,End date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Table-17"
        },
        "keys": {
          "type": "value",
          "value": "affiliation_name,position_name,amount,base_ot,position_pay,license_allowance,language_pay,skill_pay,social_security_amount,provident_fund_amount,tax_deduction_amount,net_payment,start_date,end_date"
        },
        "minRows": {
          "type": "code",
          "value": "3"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "value",
          "value": "^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80,^80"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-19"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม",
          "valueEN": "ADD"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Button-21"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAdd"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{display: props.detail? \"\":\"none\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการจ่ายเงินพนักงาน",
          "valueEN": "Employee payment detail"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontWeight: \"bold\", margin: \"1rem 0 0.5rem\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", backgroundColor: \"rgba(191, 234, 251, 1)\", borderRadius: \"3px\", marginBottom: \"1rem\", padding: \"0.35rem\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "สังกัด:",
          "valueEN": "Affiliation:"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginRight: \"0.25rem\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "props.affiliateName"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่ง:",
          "valueEN": "Position:"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"0 0.25rem  0 1rem\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "props.positionName"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Form",
      "parent": 44,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Form-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 52,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.amount? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-56"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินเดือน/ค่าจ้าง",
          "valueEN": "Salary/Wages"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "ฐานโอที/ชั่วโมง",
          "valueEN": "Base OT / hours"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-58"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", width: \"160px\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินเดือนประจำตำแหน่ง",
          "valueEN": "Position Pay"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-59"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", width: \"110px\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "label",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "ค่าใบอนุญาต",
          "valueEN": "License Allowance"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-60"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Input",
      "parent": 53,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-61"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "amount"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.amount?? \"\""
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Input",
      "parent": 54,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-62"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "base_ot"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.base_ot ?? \"\""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Input",
      "parent": 55,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-63"
        },
        "label": {
          "type": "code",
          "value": ""
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "position_pay"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.position_pay ?? \"\""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Input",
      "parent": 56,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-64"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "license_allowance"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.license_allowance ?? \"\""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", minWidth: \"max-content\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Input",
      "parent": 66,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-70"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "language_score"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.language_score ?? \"\""
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "คะแนนภาษา",
          "valueEN": "Language Score"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.langScoreInfo"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "การจ่ายเงินค่าภาษา",
          "valueEN": "Language Pay"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-73"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", width: \"160px\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Input",
      "parent": 67,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-74"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "language_pay"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.language_pay ?? \"\""
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 76,
      "name": "DateTextBox",
      "parent": 75,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-DateTextBox-76"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeValue?.(null,{name: \"language_expired_at\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.language_expired_at ?? \"\""
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "การจ่ายเงินวันหมดอายุ",
          "valueEN": "Expiry Pay"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-77"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", width: \"110px\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-78"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 78,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-79"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 78,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-80"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", minWidth: \"max-content\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "ระดับทักษะ จ่าย",
          "valueEN": "Level skill Pay"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-82"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", width: \"160px\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Input",
      "parent": 80,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-83"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "skill_pay"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.skill_pay ?? \"\""
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Input",
      "parent": 79,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-84"
        },
        "min": {
          "type": "code",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "skill_score"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.skill_score ?? \"\""
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "Level skill Score "
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-85"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.levelSkillScoreInfo"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-86"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.has_social_security? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-90"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-91"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-94"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-95"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-96"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Input",
      "parent": 94,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-99"
        },
        "min": {
          "type": "value",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "provident_fund_perc"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.provident_fund_perc ?? \"\""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "label",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนเงินกองทุนสำรองเลี้ยงชีพ",
          "valueEN": "Provident Fund Amount"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-102"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"200px\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "label",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": "Social Security Deduction Amount "
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-103"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"200px\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "Input",
      "parent": 91,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-104"
        },
        "min": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.detail?.social_security_amount??\"\""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Input",
      "parent": 96,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-105"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.provident_fund_amount ?? \"\""
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": "สิทธิ์การเข้ารับประกันสังคม",
          "valueEN": "Social Security Eligibility"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-106"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": "% กองทุนสำรองเลี้ยงชีพ",
          "valueEN": "% Provident Fund"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-107"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Radio",
      "parent": 108,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.detail?.has_social_security ===true "
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Radio-109"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "Yes"
        },
        "name": {
          "type": "value",
          "value": "has_social_security"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Radio",
      "parent": 108,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.detail?.has_social_security === false"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Radio-110"
        },
        "label": {
          "type": "value",
          "value": "เลขที่",
          "valueEN": "No"
        },
        "name": {
          "type": "value",
          "value": "has_social_security"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        },
        "value": {
          "type": "code",
          "value": "false"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 111,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 111,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 111,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 111,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 111,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-117"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 111,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormField",
      "parent": 111,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.tax_deduction_amount? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-119"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Button",
      "parent": 112,
      "props": {
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Button-120"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCalWHT"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "Icon",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Icon-121"
        },
        "name": {
          "type": "value",
          "value": "refresh"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "label",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": "การคำนวณ WHT",
          "valueEN": "WHT CALCULATION"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-122"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "Label",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.formattedWHTAmount|| \"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Label-123"
        },
        "size": {
          "type": "value",
          "value": "large"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(255, 244, 212, 1)\", width: \"100%\"}"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "label",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": "การคำนวณ WHT อัตโนมัติ",
          "valueEN": "Automatic WHT Calculation"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-124"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Radio",
      "parent": 115,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.detail?.isAutoWHTCalculation===true"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Radio-125"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "Yes"
        },
        "name": {
          "type": "value",
          "value": "isAutoWHTCalculation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "Radio",
      "parent": 117,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.detail?.isAutoWHTCalculation===false"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Radio-126"
        },
        "label": {
          "type": "value",
          "value": "เลขที่",
          "valueEN": "No"
        },
        "name": {
          "type": "value",
          "value": "isAutoWHTCalculation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "false"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "label",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "เงื่อนไขการหักลดหย่อนภาษี",
          "valueEN": "Tax Deduction Conditions"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-127"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "Dropdown",
      "parent": 118,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Dropdown-128"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "tax_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.revenueTaxTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.tax_type?? \"\""
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวน",
          "valueEN": "Amount"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-129"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "Input",
      "parent": 119,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-130"
        },
        "min": {
          "type": "value",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "tax_deduction_amount"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+]$/.test(e.key) && e.preventDefault()"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.tax_deduction_amount?? \"\""
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-131"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-132"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-133"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "FormGroup",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-134"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "FormField",
      "parent": 131,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.net_payment? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-135"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "FormField",
      "parent": 131,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.payment_info? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-136"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5rem\",position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormField",
      "parent": 132,
      "props": {
        "className": {
          "type": "code",
          "value": "props.detail?.payment_info===\"CASH\"?\"\":`required ${props.showRequiredField?.bank ? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-137"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 132,
      "props": {
        "className": {
          "type": "code",
          "value": "props.detail?.payment_info===\"CASH\"?\"\":`required ${props.showRequiredField?.bank_branch? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5rem\",position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormField",
      "parent": 133,
      "props": {
        "className": {
          "type": "code",
          "value": "props.detail?.payment_info===\"CASH\"?\"\":`required ${props.showRequiredField?.bank_account? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 133,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 134,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.start_date? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 134,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.end_date? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5rem\",position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "label",
      "parent": 135,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนเงินที่จ่ายสุทธิ",
          "valueEN": "Net pay amount"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-143"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"140px\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "label",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อธนาคาร",
          "valueEN": "Bank name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-144"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"140px\"}"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "label",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขบัญชีธนาคาร",
          "valueEN": "Bank Account Number"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-145"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"140px\"}"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "label",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มต้น",
          "valueEN": "Start Date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-146"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"140px\"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "label",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อสาขาธนาคาร",
          "valueEN": "Bank branch name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-147"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"130px\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "label",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สิ้นสุด",
          "valueEN": "End Date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-148"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"130px\"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "label",
      "parent": 140,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบัญชีธนาคาร",
          "valueEN": "Bank account type"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-149"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"130px\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "label",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลการชำระเงิน",
          "valueEN": "Payment Information"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-150"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"130px\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "Input",
      "parent": 135,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Input-151"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.net_payment??\"\""
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "Dropdown",
      "parent": 136,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Dropdown-152"
        },
        "name": {
          "type": "value",
          "value": "payment_info"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.salaryPaymentTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.payment_info ?? \"\""
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "Dropdown",
      "parent": 137,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.detail?.payment_info===\"CASH\" || props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Dropdown-153"
        },
        "name": {
          "type": "value",
          "value": "bank"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.bankOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.bank ?? \"\""
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "Dropdown",
      "parent": 140,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.detail?.payment_info===\"CASH\" || props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Dropdown-156"
        },
        "name": {
          "type": "value",
          "value": "bank_account_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.bankAccountTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.bank_account_type ?? \"\""
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-159"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 160,
      "name": "DateTextBox",
      "parent": 159,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-DateTextBox-160"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeValue?.(null,{name: \"end_date\", value})"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.detail?.end_date ?? \"\""
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 162,
      "name": "DateTextBox",
      "parent": 161,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-DateTextBox-162"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeValue?.(null,{name: \"start_date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.start_date ?? \"\""
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.loadingCheckbox"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-163"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "Form",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Form-164"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormGroup",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormGroup-165"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\"}"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormField",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-166"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormField",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-167"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "FormField",
      "parent": 165,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-FormField-168"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 167,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-169"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "Button",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Button-170"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCancel"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.amount|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.has_social_security|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", left: \"0\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 135,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.net_payment|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.tax_deduction_amount|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-174"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.payment_info|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 137,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.bank|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-176"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 138,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.bank_branch|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.bank_account|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-178"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.start_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-179"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.end_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-180"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "Dropdown",
      "parent": 138,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-Dropdown-181"
        },
        "name": {
          "type": "value",
          "value": "bank_branch"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.bankBranchOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.bank_branch ?? \"\""
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "code",
          "value": "props.bankAccount"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "props.employeeFullName|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeePaymentDetailUX-label-183"
        }
      },
      "seq": 183,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeePaymentDetailUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
